import { useEffect, useState } from 'react';
import { BsCart } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PORTFOLIO_DOWNLOAD_FILENAME, PORTFOLIO_DOWNLOAD_PATH } from '../constants/portfolio';

function Header() {
  const { cart } = useSelector((state) => state.product);
  const { user } = useSelector((state) => state.auth);
  const [isHidden, setIsHidden] = useState(false);

  const isAdmin = user;

  // Calculate total items in cart
  const cartItemCount = cart ? cart.reduce((total, item) => total + item.quantity, 0) : 0;

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY > lastScrollY && currentY > 80) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
      lastScrollY = currentY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`header${isHidden ? ' header--hidden' : ''}`}>
        {isAdmin ? 
        <div className='header-container'>
            <div className="header-menu">
                <Link to="/logout">Logout</Link>
                <Link to="/admin/artworks">Artworks</Link>
                <Link to="/admin/products">Products</Link>
                <Link to="/admin/orders">Orders</Link>
            </div>
        </div>
        : 
        <div className='header-container'>
            <div className="header-menu">
                <Link to="/">Home</Link>
                <Link to="/about">About</Link>
                <Link to="/shop">Shop</Link>
                <a href={PORTFOLIO_DOWNLOAD_PATH} download={PORTFOLIO_DOWNLOAD_FILENAME}>Portfolio</a>
            </div>
            <div className="header-cart">
                <Link to="/cart" className="cart-link">
                    <div className="cart-icon-container">
                        {cartItemCount > 0 && (
                            <span className="cart-counter">{cartItemCount}</span>
                        )}
                        <BsCart size={24} />
                    </div>
                </Link>
            </div>
        </div>
        }
{/* 
        <div className="header-banner">
            THE WEBSITE IS IN TEST MODE AND NO REAL PAYMENTS WILL WORK
        </div> */}
    </div>
    
  )
}

export default Header;
